import { render, staticRenderFns } from "./TrainingVideosSingle.vue?vue&type=template&id=c92b043c&scoped=true&"
import script from "./TrainingVideosSingle.vue?vue&type=script&lang=js&"
export * from "./TrainingVideosSingle.vue?vue&type=script&lang=js&"
import style0 from "./TrainingVideosSingle.vue?vue&type=style&index=0&id=c92b043c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92b043c",
  null
  
)

export default component.exports